import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import "./scss/main.scss";
import App from "./app/App";
import { store } from "./app/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>,
);
